<template>
  <div>
    <search-esim-operation-records @submit="submitSearch" />

    <a-table
      size="middle"
      :columns="columns"
      :data-source="data"
      :loading="loading"
      :scroll="{ x: 'max-content' }"
      :pagination="false"
      row-key="id"
    >
      <span slot="actions" slot-scope="text, record">
        <a
          v-if="record.abortable"
          :disabled="actingId === record.id"
          @click="confirmAbort(record)"
        >中止</a>
        <span v-else>-</span>
      </span>
    </a-table>

    <pagination
      v-show="pagination.total_count > 0"
      :total-count="pagination.total_count"
      :page.sync="query.page"
      :per-page.sync="query.per_page"
      @change="fetchData"
    />
  </div>
</template>

<script>
import { findEsimEimOperationTasks, abortEsimEimOperationTask } from '@/api/esim'
import Pagination from '@/components/Pagination'
import SearchEsimOperationRecords from '@/views/esims/info/OperationRecordsSearch'

export default {
  name: 'ShowEsimOperationRecords',
  components: {
    Pagination,
    SearchEsimOperationRecords
  },
  props: {
    id: { type: Number, required: true }
  },
  data() {
    return {
      loading: false,
      actingId: 0,
      data: [],
      pagination: {
        total_count: 0
      },
      query: {
        per_page: 10
      },
      columns: [
        { title: '操作类型', dataIndex: 'execute_type_name', width: 120 },
        { title: 'ICCID', dataIndex: 'iccid', width: 200 },
        { title: '状态', dataIndex: 'status_name', width: 90 },
        { title: '上游状态', dataIndex: 'upstream_status', width: 100 },
        { title: '事务号', dataIndex: 'transaction_id', width: 160 },
        { title: '失败原因', dataIndex: 'failure_reason', width: 160 },
        { title: '提交时间', dataIndex: 'created_at', width: 160 },
        { title: '完成时间', dataIndex: 'finished_at', width: 160 },
        { title: '操作', dataIndex: 'actions', scopedSlots: { customRender: 'actions' }, width: 80 }
      ]
    }
  },
  created() {
    this.fetchData()
  },
  activated() {
    this.fetchData()
  },
  methods: {
    submitSearch(search) {
      this.query = Object.assign({}, this.$options.data().query, { per_page: this.query.per_page }, search)
      this.fetchData()
    },
    fetchData() {
      this.loading = true
      findEsimEimOperationTasks(this.id, this.query).then((res) => {
        if (res.code === 0) {
          this.data = res.data || []
          this.pagination = res.pagination || { total_count: 0 }
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    confirmAbort(record) {
      const vm = this
      this.$confirm({
        title: '确认中止该指令？',
        content: '',
        okText: '确定',
        okType: 'danger',
        cancelText: '取消',
        onOk() {
          return vm.abortTask(record)
        }
      })
    },
    abortTask(record) {
      this.actingId = record.id
      return abortEsimEimOperationTask(this.id, record.id).then((res) => {
        this.actingId = 0
        if (res.code === 0) {
          this.$message.success((res.data && res.data.message) || '已中止')
          this.fetchData()
        }
      }).catch(() => {
        this.actingId = 0
      })
    }
  }
}
</script>
